import React, { use } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { LotDetailContext } from "../../../../Contexts/LotDetailContext";

export function LineField() {
    const { t } = useTranslation();
    const {
        lotDetail: {
            summary: {
                productionLine,
            }
        }
    } = use(LotDetailContext);

    return (
        <Form.Group as={Col} sm={6} className="col-sm-6" controlId="formLine">
            <Row>
                <Form.Label column sm={4}>{`${t('LotDetails.Summary.Line')}:`}</Form.Label>
                <Col sm={8}>
                    <Form.Control type="text" disabled className="as-label" value={productionLine ?? ""} />
                </Col>
            </Row>
        </Form.Group>
    );
}